var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInputEyeOpen = function SvgInputEyeOpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 18,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.244 4.454C5.428 3.54 6.887 2.788 8.5 2.788s3.072.752 4.256 1.666c1.19.918 2.164 2.046 2.818 2.905l.054.07c.394.516.718.94.718 1.571 0 .63-.324 1.055-.718 1.57l-.054.071c-.654.859-1.627 1.987-2.818 2.905-1.184.914-2.643 1.665-4.256 1.665s-3.072-.751-4.256-1.665c-1.19-.918-2.164-2.046-2.818-2.905l-.054-.07C.978 10.055.654 9.63.654 9c0-.63.324-1.055.718-1.57l.054-.071C2.08 6.5 3.053 5.372 4.244 4.454M5.884 9c0-1.43 1.172-2.588 2.616-2.588S11.115 7.57 11.115 9s-1.17 2.588-2.615 2.588c-1.444 0-2.615-1.159-2.615-2.588m1.047 0c0-.858.702-1.553 1.569-1.553s1.57.695 1.57 1.553-.703 1.553-1.57 1.553S6.93 9.858 6.93 9",
    clipRule: "evenodd"
  })));
};
export { SvgInputEyeOpen as ReactComponent };